export default "__VITE_ASSET__CB5M5RPn__"